import { Component } from '@angular/core';

@Component({
    selector: 'app-quoterequests',
    templateUrl: './quoterequests.component.html',
    standalone: false,
})
export class QuoteRequestsComponent {}
